export const environment = {
  production: false,
  appVersion: '1.0.0',
  secretKey: 'fc6a6591f2b6fc9d51d8360b38511216fba3c9cc35babb7594da98c0bd8391c0',
  // apiUrl: 'https://0nvboitpb5.execute-api.ap-south-1.amazonaws.com/dev/', d2kd17rqcjy5rl.cloudfront.net
  apiUrl: 'https://d2fuumz9iyi0xz.cloudfront.net/dev/',
  logoPath: 'assets/images/backgrounds/medistrat_logo_svg.svg',
    loginPath:'/assets/images/backgrounds/medistrat_logo_svg.svg',

  title: 'Medistrat | LMS',
  favicon: 'assets/images/backgrounds/medistrat_logo_svg.svg',
  meta: {
    title: 'Medistrat | LMS',
    description: 'Medistrat LMS provides structured medical education for professionals with easy access to learning modules and certifications.',
    image: 'https://hoepharmaceuticals.medistrat.com.my/assets/images/backgrounds/medistrat_logo_svg.svg',
    url: 'https://hoepharmaceuticals.medistrat.com.my',
    type: 'website'
  }
};
